<fullscreen-page>
  <navigation-column>
    <div class="p-2 h-100 d-flex flex-column">
      <div class="dx-field" style="margin: 0 0 5px;">
        <div class="dx-field-label">{{'System' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="classificationSystems"
                         [(value)]="selectedClassificationSystem"
                         [displayExpr]="getClassificationSystemDisplayText"
                         [disabled]="loadingClassificationClasses"
                         (onValueChanged)="onClassificationSystemChanged($event)">
            <dxo-drop-down-options [width]="400"></dxo-drop-down-options>
          </dx-select-box>
        </div>
        <dx-button stylingMode="text" hint="{{ 'Klassifizierungs-System erstellen' | translate }}" type="default"
                   icon="plus" (onClick)="showCreateClassificationSystemPopup()" />
        <dx-button stylingMode="text" hint="{{ 'Klassifizierungs-System duplizieren' | translate }}" type="default"
                   icon="copy" (onClick)="showDuplicateClassificationSystemPopup()" />
        <dx-button stylingMode="text" hint="{{ 'Katalog mit System-Struktur erstellen' | translate }}" type="default"
                   icon="export" (onClick)="createCatalogWithClassification()" />
        <dx-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                   stylingMode="text" hint="{{ 'Klassifizierungs-System bearbeiten' | translate }}" type="default"
                   icon="edit" (onClick)="showEditClassificationSystem()" />
        <dx-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                   stylingMode="text" hint="{{ 'Klassifizierungs-System löschen' | translate }}" type="default"
                   icon="trash" (onClick)="deleteClassificationSystem()" />
        <dx-button *ngIf="loginService.isAdmin && edcSelected"
                   stylingMode="text" hint="{{ 'Klassifizierungs-System aktualisieren' | translate }}" type="default"
                   icon="refresh" (onClick)="refreshClassificationSystem()" />
      </div>
      <classificationTree class="overflow-hidden"
                          [(selectedClassificationSystem)]="selectedClassificationSystem"
                          [(loadingClassificationClasses)]="loadingClassificationClasses"
                          [(classificationClasses)]="classificationClasses"
                          (selectedClassificationClassChanged)="fillFeaturesInClassificationClass($event)"/>
    </div>
  </navigation-column>
  <content-column helpSwitch="true" look="light">  
    <div slot="content" class="p-2 flex-fill overflow-hidden">
      <classificationGroup [(selectedClassificationClass)]="selectedClassificationClass"
                           [(selectedClassificationSystem)]="selectedClassificationSystem"
                           [(classificationClasses)]="classificationClasses"/>
    </div>
  </content-column>
</fullscreen-page>

<dx-popup [width]="500"
          [height]="300"
          [showTitle]="true"
          title="{{ 'Klassifizierungs-System erstellen' | translate }}"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          contentTemplate="popupContent"
          [(visible)]="createClassificationSystemPopupVisible">
  <dxi-popup-toolbar-item widget="dxButton"
                          toolbar="bottom"
                          location="after"
                          [options]="{ stylingMode: 'outlined', text: 'Erstellen' | translate, onClick: createClassificationSystem }">
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'popupContent'">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newClassificationSystem.name" [showClearButton]="true"></dx-text-box>
      </div>
    </div>
    <div *ngIf="loginService.isAdmin" class="dx-field">
      <div class="dx-field-label">{{ 'Global' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="newClassificationSystem.isGlobal"></dx-switch>
      </div>
    </div>
  </div>
</dx-popup>

<dx-popup [width]="500"
          [height]="300"
          [showTitle]="true"
          title="{{ 'Klassifizierungs-System aktualisieren' | translate }}"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          contentTemplate="popupContent"
          [(visible)]="showClassificationFileUpload">
  <div *dxTemplate="let data of 'popupContent'">
    <dx-file-uploader #fileUploader
                      name="file"
                      uploadUrl="api/import/importClassificationSystemChunky"
                      [uploadHeaders]="uploadHeaders"
                      [multiple]="false"
                      [chunkSize]="10000000"
                      [accept]="fileTypes"
                      uploadMode="instantly"
                      (onBeforeSend)="onBeforeSendUpload($event)"
                      (onUploaded)="onUploaded()"
                      invalidFileExtensionMessage="{{ 'Bitte nur xml zip xlsx xls oder csv Dateien auswählen' | translate }}."
                      invalidMaxFileSizeMessage="{{ 'Die Datei ist leider zu groß' | translate }}"
                      invalidMinFileSizeMessage="{{ 'Die Datei ist leider zu klein' | translate }}"
                      selectButtonText="{{ 'Datei auswählen' | translate }}"
                      labelText="{{ 'oder Datei hier ablegen' | translate }}"
                      uploadButtonText="{{ 'Upload' | translate }}"
                      uploadedMessage="{{ 'Hochgeladen' | translate }}"
                      uploadFailedMessage="{{ 'Hochladen fehlgeschlagen' | translate }}">
    </dx-file-uploader>
  </div>
</dx-popup>
